export const valueChain = {
    title: 'バリューチェーン',
    tooltip:
        'バリューチェーンを構成する要素（開発、製造、調達、サービス）ごとに、UIで指定したテーマに関連する技術に関心の高い業界と企業（潜在顧客、仮想競合）と、その関心の高い開発トレンド（技術クラスタ）を把握することができます。UIで指定したクラスタ内の技術を保有する企業等のイノベーション評価結果（スコア、インパクト又はスタートアップはステージ）のランキングリストがUIに表示されるので、ユーザーは事業規模や、ラウンド情報を保有かつ設立年で、事業会社又はスタートアップ企業でのアライアンス候補先のリストを作成することができます。',
    valueChainLabel: 'バリューチェーン',
    naceLabel: 'プロセス',
    usLabel: '産業分類',
    ipcLabel: 'クラスタを選択',
    filterCompany: '企業を選択',
    clusterLabel: 'クラスタ',
    optional: ' (オプション)',
    chart1XAxisScore: 'スコア',
    chart1XAxisImpact: 'インパクト',
    chart1YAxisScale: '事業規模[千米ドル]',
    chart1YAxisAmount: 'マイノリティ出資額[百万円]',

    table1Title: '企業イノベーションスコアシート',
    table1CompanyName: '企業',
    table1Score: 'スコア',
    table1Scale: '事業規模[千米ドル]',
    table1Impact: 'インパクト',
    table1Stage: '成長ステージ',
    table1BusinessImpace: 'ビジネスインパクト',
    table1Amount: 'マイノリティ出資額[百万円]',
    table1Year: '設立年',

    table2Title: 'クラスタの投資状況',
    table2ToCompany: '投資先企業',
    table2FromCompany: '投資元企業',
    table2Amount: 'マイノリティ出資額[百万円]',

    chart2Title: '成長ステージ評価',
    chart2XAxisStage: '成長ステージ',
    chart2XAxisScore: '知財イノベーション評価スコア',
    chart2YAxisScale: '事業規模[千米ドル]',
    chart2YAxisImpact: 'ビジネスインパクト',
    chart2YAxisAmount: 'マイノリティ出資額[百万円]',

    wordCloudTitle: 'クラスタのワードクラウド',
    wordCloudBarTitle: 'クラスタの頻出ワード',
    xAxis: 'X軸',
    yAxis: 'Y軸',
    chart1Title: 'スタートアップ',
    chartClusterId: 'クラスタID',
    chart3Title: '事業会社',
    chart1XAxisStage: '成長ステージ',

    groupBy: 'グループ化',
    investmentStatusTable: '投資状況',
    companyTableColumn: '企業名',
    naceLabelTableColumn: 'カテゴリー_1',
    usLabelTableColumn: 'カテゴリー_2',
    targetAmountTableColumn: 'マイノリティ出資額[百万円]',
    investmentAmountTableColumn: 'ソース量',

    selectedCompanyWithoutPatent: '特許もっていない企業',
    selectedCompanyIncluded: '選択した企業を含むクラスタ',
    selectedCompanyExcluded: '選択した企業を含まないクラスタ',
    selectedCompanyWithLabel: '選択した企業を含ラベル',

    companyName: '企業名',
    patentcount: '特許出願件数',
    impact: 'インパクト',

    target: '投資先',
    investment: '投資元',
    // Startup without patent
    titleStartUpWithoutPatentTable: '特許未保有のスタートアップ企業',
    filterYear: '設立年',
    inYears: '{{n}}年以内',
    tblStartUpWithoutPatentCompany: '企業',
    tblStartUpWithoutPatentOverview: '事業概要',
    tblStartUpWithoutPatentSourceCompany: '投資元企業',
    tblStartUpWithoutPatentAmount: 'マイノリティ出資額[百万円]',
    tblStartUpWithoutPatentMatch: '類似度',
    tblStartUpWithoutPatentMatchYear: '設立年',

    patentTableTitile: '選択した企業の特許一覧',
    downloadTitle: '完全な特許一覧をダウンロード',
    tableColumnPublication: '公開番号／特許番号',
    tableColumnIPCMain: '筆頭IPC',
    tableColumnIPCOther: 'その他のIPC',
    tableColumnIPCTitle: '発明の名称',
    tableColumnOwner: '特許保有企業',
    tableColumnInventor: '発明者',
    tableColumnFLQ: '因子負荷量',
    tableColumnImpact: 'インパクト',
    tableColumnApplicationYear: '出願年',

    // Switch btn and RadioGroup
    CompanySelectMode: '企業選択',
    LabelFixMode: 'ラベル固定',
    labelShowMore: '企業名、特許出願件数',
    labelShowOnlyCluster: '企業名のみ'
}
